import React from "react";
import VideoModal from "../ModalVideo/VideoModal";
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';
import abImg from '../../images/about/about-1/1.jpg';
import abImg2 from '../../images/about/about-1/2.jpg';
import RollingText from "../RollingText/RollingText";

const About = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }


    return (
        <section id="about" className={"" + props.hclass}>
            <div className="about-wrap">
                <div className="content">
  <h2
    className="scroll-text-animation"
    data-animation="fade_from_right"
  >
    About YVReddy<br />Associates
  </h2>

  <p className="fade_bottom">
    YV Reddy Associates is a well-established civil, architectural, and interior
    contracting firm with decades of experience delivering high-quality
    corporate, commercial, and institutional projects across India. Renowned
    for precision, reliability, and design excellence, we transform concepts
    into functional, future-ready spaces.
  </p>

  <p className="fade_bottom">
    Our expertise spans corporate office interiors, architectural planning,
    turnkey project execution, and space optimization. Backed by a skilled team
    of engineers, designers, and project managers, we ensure seamless
    coordination, strict quality control, and on-time delivery—every time.
  </p>

  <div className="about-btn">
    <Link onClick={ClickHandler} to="/about" className="theme-btn">
      <RollingText text={'Discover More'} />
    </Link>

    <div className="video-wrap">
      <div className="video-holder">
        <VideoModal />
      </div>
      {/* <span>Watch Videos</span> */}
    </div>
  </div>

  <div className="about-funfact fade_bottom">
    <h3>
      <span><CountUp end={23} enableScrollSpy /></span>
      <span className="icon">+</span>
    </h3>

    <h4>
      Years Of <br />
      Industry Experience
    </h4>
  </div>
</div>

            </div>
            <div className="image">
                <div className="image-1  poort-in-right">
                    <img src={abImg} alt="" />
                </div>
                <div className="image-2 poort-in-right">
                    <img src={abImg2} alt="" />
                </div>
            </div>
        </section>
    )
}

export default About;
